import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVEdTechStoreKeyMap } from './mmkvEdTechStoreKeyMap';

export const mmkvEdTechAppPersistence = new MMKV({
  id: MMKVEdTechStoreKeyMap.edTechAppSettings,
});

export const zustandEdTechAppStorage: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvEdTechAppPersistence.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvEdTechAppPersistence.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvEdTechAppPersistence.delete(name);
  },
};
